import React from "react";
import { view } from "@risingstack/react-easy-state";

import appStore from "../../../../stores/appStore";

import Block from "../../../Block";
import MANALoader from "../../../MANALoader";
import TermStructureChart from "./TermStructureChart";

const PeChart = () => {
  const { peChartData } = appStore.termStructureChartData;

  if (!peChartData) return <MANALoader />;

  const margin = {
    left: 22,
    right: 0,
    top: 20,
    bottom: 24,
  };

  return (
    <Block>
      {{
        basic: true,
        classes: "chart-container",
        content: (
          <TermStructureChart
            chartData={peChartData}
            margin={margin}
            tickFormat={(tick) => tick}
          />
        ),
      }}
    </Block>
  );
};

export default view(PeChart);
